import React from 'react';
import { omit } from 'ramda';
import { FormInput } from './FormInput';
import { FormFieldError } from './FormFieldError';

export const FormField = ({ Component = FormInput, name, label, props: componentProps, children, error, ...props }) => (
  <div className="mb-[31px] text-left">
    <label htmlFor={name}>{label}</label>
    <Component name={name} {...omit(['default'], props)} {...componentProps}>
      {children}
    </Component>
    {error && <FormFieldError>{error}</FormFieldError>}
  </div>
);
